import { Component, Input, Output, EventEmitter } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Observable, Subscription } from "rxjs";
import { ClientModel } from "src/app/core/models/members/client/client.model";
import { ContactModel } from "src/app/core/models/contact/contact.model";
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { RequisitionStatusType } from "src/app/core/models/requisition/requisition-base.model";
import { RequisitionSearchModel } from "src/app/core/models/requisition/requisition-search.model";
import { RequisitionModel } from "src/app/core/models/requisition/requisition.model";
import { UserBaseModel } from "src/app/core/models/members/user/user-base.model";
import { SecurityOperations } from "src/app/core/security/security-operations";
import { AuthMyfileService } from "src/app/core/services/auth.myfile.service";
import { RequisitionListService } from "src/app/core/services/list-services/requisition-list.service";
import { OpenModalService } from "src/app/core/services/modal-services/open-modal.service";
import { PdfViewerModalService } from "src/app/core/services/modal-services/pdf-viewer-modal.service";
import { MyfileApiService } from "src/app/core/services/myfile-api.service";
import { ToasterNotificationService } from "src/app/core/services/toaster-notification.service";
import Swal from "sweetalert2";
import { RequisitionListSortBy } from "src/app/core/enums/sort-by-options/requisition-list-sort-enum";
import { ListLayoutExtendableComponent } from "../list-layout/list-layout-extendable/list-layout-extendable.component";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { ServiceData } from "src/app/core/models/table/service-data.model";
import { ListFilterModel } from "src/app/core/models/table/list-filter.model";
import { TableActionsModel } from "src/app/core/models/table/table-action.model";
import { SortByTypeEnum } from "src/app/core/enums/list-layout/sort-type-enum";
import { EmitSortModel } from "src/app/core/models/table/emit-sort.model";
import { RequisitionListConfig } from "./configs/requisition-list.config";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ActivatedRoute, Router } from "@angular/router";
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ExportType } from "src/app/core/models/reporting/export-config-model";
import { BadgeCountService } from "src/app/core/services/badgecount.service";
import { TableConfigService } from "src/app/core/services/table-config.service";
import { GlobalComponent } from "src/app/global-component";
import { TableRequisitionFilter } from "./configs/table-requisition-filter-config-enum";
import { RequisitionStatus } from "src/app/core/enums/requisition-status-enum";
import { FilterModel } from "src/app/core/models/security/filters.model";
import { RequisitionViewAssigned } from "src/app/core/enums/requisition-view-assigned-enum";
import { AssigneesModalService } from "src/app/core/services/modal-services/assignees-modal.service";

@Component({
  selector: 'app-requisition-list',
  templateUrl: './requisition-list.component.html',
  styleUrls: ['./requisition-list.component.scss'],
  providers: [RequisitionListService],
})
export class RequisitionListComponent extends ListLayoutExtendableComponent {


  tableConfig: TableConfigurationModel = new TableConfigurationModel();
  serviceData: ServiceData = new ServiceData();

  newRequisitionLink = "/marketplace/explore"

  protected override searchPlaceHolderText: string = $localize`:@@:Search for requisition number, name, last name, or email`;

  sortBy: RequisitionListSortBy = RequisitionListSortBy.None;
  requisitionStatus = RequisitionStatus;

  override listItemsObservable!: Observable<RequisitionModel[]>;

  securityPermissionRequisitionCreate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionCreate);
  securityPermissionRequisitionDelete: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionDelete);
  securityPermissionRequisitionManagement: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionManagement);
  securityPermissionRequisitionUpdate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionUpdate);


  securityPermissionTimeLineManagement: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.timeLine.timeLineManagement);
  securityPermissionContactManagement: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.account.accountManagement);
  securityPermissionClientManagement: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.client.clientManagement);

  configItemsObservable!: Observable<TableConfigurationModel[]>;

  constructor(
    protected url: ActivatedRoute,
    public requisitionListService: RequisitionListService,
    protected badgeCountService: BadgeCountService,
    protected tableConfigService: TableConfigService,
    protected assigneesModalService: AssigneesModalService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override openModalService: OpenModalService,
    protected router: Router
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }
  @Input() public clientLimitedSearch: string | undefined = undefined;
  @Input() public customListLayOut: TableConfigurationModel | undefined = undefined;
  @Input() public startStatus: RequisitionStatusType | undefined | any = undefined;
  @Input() public requisitionStateList: RequisitionSearchModel | undefined = undefined;

  @Output() totalChange = new EventEmitter<any>();

  get requisitionsViewModel(): RequisitionModel[] { return this.listItems; }

  public clearRequisitionList(): void {
    this.requisitionListService.clearListService();
    this.assignRequisitionsToViewModel(new Array<RequisitionModel>());
  }

  ngOnInit(): void {
    this.url.queryParams.subscribe(params => {
      if (params['reqId'] != undefined && params['reqId'].length > 0) {
        this.requisitionListService.reqId = params['reqId'];
      }
    })


    if (this.customListLayOut != undefined) {
      this.tableConfig = this.customListLayOut;
    } else {
      this.tableConfig = new RequisitionListConfig();
    }

    this.configItemsObservable = this.tableConfigService.resultItems$;
    const subscrConfig = this.configItemsObservable.subscribe(result => {
      if (result && result[0]) {

        //Do not load Saved Preferences if the Table Config Version saved is out of date. 
        if (result[0].version == this.tableConfig.version) {
          //needed to be able to avoid null from the model when its decoded. 
          this.tableConfig = JSON.parse(JSON.stringify(result[0], (key, value) => {
            if (value !== null) return value;
          }));
          if (this.tableConfig.pageSize !== GlobalComponent.defaultPagingInfo.pageSize) {
            this.requisitionListService.pageSize = this.tableConfig.pageSize;
          }
        }

      }
    });
    this.unsubscribe.push(subscrConfig);

    this.tableConfigService.createdById = undefined;
    this.tableConfigService.listTitle = this.tableConfig.listTitle!;

    this.listItemsObservable = this.requisitionListService.resultItems$;
    this.total = this.requisitionListService.total$;
    this.isLoading = this.requisitionListService.loading$;

    if (this.startStatus != undefined) {
      this.requisitionListService.status = this.startStatus;
    }


    this.requisitionListService.assigneeIds = this.authMyFileService.currentUserContextValue?.id;

    if (this.clientLimitedSearch != undefined) {
      this.requisitionListService.clientLimitedSearch = this.clientLimitedSearch;
    }

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true
      } else {
        this.serviceData.loadingValue = false
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.assignRequisitionsToViewModel(result);
      this.listItems.forEach((requisitionModel: RequisitionModel) => {
        requisitionModel = this.addEntityType(requisitionModel, EntityTypeEnum.Requisition);
        requisitionModel.account = this.addEntityType(requisitionModel.account, EntityTypeEnum.Account);
        requisitionModel.client = this.addEntityType(requisitionModel.client, EntityTypeEnum.Client);
        requisitionModel.createdBy = this.addEntityType(requisitionModel.createdBy, EntityTypeEnum.User);
        if (requisitionModel.assignees && requisitionModel.assignees.length > 0) {
          requisitionModel.assignees.forEach((assignee) => {
            this.getEntityPhoto(assignee, EntityTypeEnum.User);
          });
        }

      });
    });
    this.unsubscribe.push(subscr2);

    const subscr3 = this.total.subscribe(result => {
      this.serviceData.totalRecords = this.requisitionListService.totalRecords;
      this.serviceData.pageSize = this.requisitionListService.pageSize;
      this.serviceData.pageIndex = this.requisitionListService.pageIndex;
    });
    this.unsubscribe.push(subscr3);

  }

  ngOnDestroy() {
    this.clearSearch(this.tableConfigService);
    this.clearSearch(this.requisitionListService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  resetList(confirmation: boolean | undefined) {
    if (confirmation) {
      if (this.customListLayOut != undefined) {
        this.tableConfig = this.customListLayOut;
      } else {
        this.tableConfig = new RequisitionListConfig();
      }
      this.requisitionListService.resetListState(confirmation);
    }
  }

  buttonActionSelected(buttonAction: any) {
    var action = buttonAction;

    if (buttonAction.buttonId !== undefined) {
      action = buttonAction.buttonId
    }

    switch (action) {
      case ButtonIdEnum.CreateNew:
        this.router.navigateByUrl('/marketplace/explore');
        break;
      case ButtonIdEnum.Delete:
        this.deleteMultipleRequisitions();
        break;
      case `${ButtonIdEnum.ExportCSV}`:
        this.exportTo(ExportType.Csv, this.requisitionListService.searchModel, 'Requisitions', 'Requisitions', this.tableConfig)
        break;
      case `${ButtonIdEnum.ExportExcel}`:
        this.exportTo(ExportType.Excel, this.requisitionListService.searchModel, 'Requisitions', 'Requisitions', this.tableConfig)
        break;
      case ButtonIdEnum.Assignee:
        this.addAssigneesToMultipleRequisitions();
        break;
    }
  }

  rowActionSelected(rowAction: TableActionsModel) {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.Edit:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openModel(rowAction.model.entityType, rowAction.model)
        break;
      case ActionIdEnum.Delete:
        if (rowAction.model != undefined && rowAction.model.id != undefined) {
          this.deleteItem(rowAction.model.id)
        }
        break;
      case ActionIdEnum.OpenModal:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openModel(rowAction.model.entityType, rowAction.model)
        break;
      case ActionIdEnum.View:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openModel(rowAction.model.entityType, rowAction.model)
        break;
      case ActionIdEnum.Notes:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openModalService.editRequisitionModal(this.requisitionListService, rowAction.model.id, this.requisitionListService.defaultRequisitionListState.sortColumnDirective, this.requisitionListService.defaultRequisitionListState.sortDirectionDirective, undefined, 3)
        var sub = this.openModalService.isLoadingVal.subscribe((result) => {
          this.isLoadingVal = result;
          sub.unsubscribe();
        })
        break;
      case ActionIdEnum.AssigneeManagement:
        this.editAssigneesOnRequisition(rowAction.model);
        break;
    }
  }

  openModel(entityType: EntityTypeEnum, model: any) {
    switch (entityType) {
      case EntityTypeEnum.Client:
        var viewModel = { ...model }
        if (viewModel.dateOfBirth != undefined) {
          viewModel.dateOfBirth = this.dateRename(viewModel.dateOfBirth);
        }
        if (viewModel.dateOfLoss != undefined) {
          viewModel.dateOfLoss = this.dateRename(viewModel.dateOfLoss);
        }
        this.serviceData.loadingValue = true;
        this.openModalService.editClientModal(this.requisitionListService, viewModel.id);
        break;
      case EntityTypeEnum.Account:
        var viewModel = { ...model }
        this.serviceData.loadingValue = true;
        this.openModalService.editContactModal(this.requisitionListService, viewModel.id);
        break;
      case EntityTypeEnum.Requisition:
        var viewModel = { ...model }
        this.serviceData.loadingValue = true;
        this.openModalService.editRequisitionModal(this.requisitionListService, viewModel.id, this.requisitionListService.defaultRequisitionListState.sortColumnDirective, this.requisitionListService.defaultRequisitionListState.sortDirectionDirective);
        var sub = this.openModalService.isLoadingVal.subscribe((result) => {
          this.serviceData.loadingValue = result;
          sub.unsubscribe();
        })
        break;
      case EntityTypeEnum.User:
        if (this.authMyFileService.canAccessOperation(SecurityOperations.user.userReadAll)) {
          var viewModel = { ...model }
          this.serviceData.loadingValue = true;
          this.openModalService.editUserModal(viewModel.id, undefined, this.requisitionListService);
        }
        break;
    }
  }

  filterSelected(filterSelected: ListFilterModel) {
    if (filterSelected.label == TableRequisitionFilter.RequisitionStatusFilter) {
      this.requisitionListService.status = filterSelected.selectedOption;
    }
    if (filterSelected.label == TableRequisitionFilter.RequisitionAssigneeFilter) {
      if (filterSelected.selectedOption == RequisitionViewAssigned.All) {
        this.requisitionListService.createdById = undefined;
        this.requisitionListService.assigneeIds = this.authMyFileService.currentUserContextValue?.id;
      } else if (filterSelected.selectedOption == RequisitionViewAssigned.Assigned) {
        this.requisitionListService.createdById = undefined;
        this.requisitionListService.assigneeIds = this.authMyFileService.currentUserContextValue?.id;
      } else if (filterSelected.selectedOption == RequisitionViewAssigned.Mine) {
        this.requisitionListService.createdById = this.authMyFileService.currentUserContextValue?.id;
        this.requisitionListService.assigneeIds = undefined;
      }

      this.requisitionListService.refresh();
    }
  }

  searchTermFilterChanged(searchTermFilters: FilterModel[]) {
    this.requisitionListService.searchTermFilterOptions(searchTermFilters, this.requisitionListService.searchTerm, true);
  }

  sortByPassedSort(passedSortModel: EmitSortModel) {
    if (passedSortModel.sortSelected == SortByTypeEnum.None) {
      this.serviceSort(this.requisitionListService, '', '');
    } else {
      this.serviceSort(this.requisitionListService, passedSortModel.fieldName, passedSortModel.sortSelected);
    }
  }

  addEntityType(model: any, entityType: EntityTypeEnum): any {
    if (model.entityType === undefined) {
      model.entityType = entityType;
    }
    return model;
  }

  assignRequisitionsToViewModel(items: RequisitionModel[]): void {
    this.listItems = Object.assign([], items);
    if (items && items.length > 0) {
      items.forEach((data: any) => {
        if (data.client) {
          this.getEntityPhoto(data.client, EntityTypeEnum.Client)
        } else {
          data.client = new ClientModel();
        }
        if (data.account) {
          this.getEntityPhoto(data.account, EntityTypeEnum.Account)
        } else {
          data.account = new ContactModel();
        }

        if (data.user) {
          this.getEntityPhoto(data.user, EntityTypeEnum.User)
        } else {
          data.user = new UserBaseModel();
        }
        if (!data.fullName) {
          data.fullName = `${data.name} ${data.lastName}`;
        }
        data.img = this.getDocumentImageUrl(data.imageUrl);
      });
    }
  }

  deleteItem(requisitionId: string, event?: any) {
    if (event) {
      this.stopPropagationOnClick(event)
    }
    Swal.fire({
      title: $localize`:@@:Delete Requisition`,
      text: $localize`:@@:Are you sure you want to delete this requisition?`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@:Ok`,
      cancelButtonText: $localize`:@@:Cancel`,
    }).then(result => {
      if (result && result.isConfirmed) {
        this.myFileApiService.deleteRequisition(requisitionId).subscribe((result: boolean | undefined) => {
          if (result) {
            this.toasterNotificationService.showSuccess($localize`:@@: Requisition has been deleted.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
          }
          this.badgeCountService.getBadgeCount();
          this.requisitionListService.sortColumn = this.requisitionListService.sortColumn;
        })
      }
    });
  }

  selectClient($event: MouseEvent, client: ClientModel) {
    $event.stopPropagation();
    if (client.id) {
      this.openModalService.editClientModal(this.requisitionListService, client.id, 'modifiedDate', 'desc')
    }
  }

  selectContact($event: MouseEvent, contact: ContactModel) {
    $event.stopPropagation();
    if (contact.id) {
      this.openModalService.editContactModal(this.requisitionListService, contact.id, 'modifiedDate', 'desc')
    }
  }

  editAssigneesOnRequisition(requisition: RequisitionModel | undefined) {
    if (requisition) {
      this.serviceData.loadingValue = true;
      this.assigneesModalService.openModal(requisition.assignees, requisition.assigneeIds, true, requisition);
      var sub: Subscription = this.assigneesModalService.modelChanged.subscribe((result: { userList: UserBaseModel[] | undefined, assigneeIds: string[] | undefined, changed: boolean }) => {
        this.serviceData.loadingValue = false;
        sub.unsubscribe();
      })
    }
  }

  addAssigneesToMultipleRequisitions() {
    var checkboxes: any = document.getElementsByName('checkAll');
    var result
    var checkedVal: any[] = [];
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        result = checkboxes[i].value;
        checkedVal.push(result);
      }
    }

    this.assigneesModalService.openModalWithBatchEditing();

    var sub: Subscription = this.assigneesModalService.modelChanged.subscribe((result: { userList: UserBaseModel[] | undefined, assigneeIds: string[] | undefined, changed: boolean }) => {

      if (result.changed == true && result.assigneeIds != undefined) {
        checkedVal.forEach(reqId => {
          var sub = this.myFileApiService.getRequisition(reqId).subscribe(reqInfo => {
            if (reqInfo) {
              if (reqInfo.assigneeIds == undefined) {
                reqInfo.assigneeIds = [];
              }
              if (reqInfo.assignees == undefined) {
                reqInfo.assignees = [];
              }
              reqInfo.assigneeIds = [...new Set(reqInfo.assigneeIds.concat(result.assigneeIds!))]
              reqInfo.assignees = [...new Set(reqInfo.assignees.concat(result.userList!))]

              this.myFileApiService.updateRequisition(reqInfo).subscribe((result: boolean | undefined) => {
                this.requisitionListService.sortColumn = this.requisitionListService.sortColumn;
              })
            }
          });
          sub.unsubscribe();
        })
      }

      this.serviceData.loadingValue = false;
      sub.unsubscribe();
    })

  }

  deleteMultipleRequisitions() {
    var checkboxes: any = document.getElementsByName('checkAll');
    var result
    var checkedVal: any[] = [];
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        result = checkboxes[i].value;
        checkedVal.push(result);
      }
    }
    if (checkedVal.length > 1) {
      Swal.fire({
        title: $localize`:@@:Delete Multiple Requisitions`,
        text: $localize`:@@:Are you sure you want to delete these requisitions?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(3, 142, 220)',
        cancelButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@:Ok`,
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        cancelButtonText: $localize`:@@:Cancel`,
      }).then(result => {
        if (result.isConfirmed) {
          for (var i = 0; i < checkedVal.length; i++) {
            var reloadList: number = checkedVal.length;
            this.myFileApiService.deleteRequisition(checkedVal[i]).subscribe((result: boolean | undefined) => {
              reloadList = reloadList - 1;
              if (reloadList == 0) {
                this.requisitionListService.sortColumn = this.requisitionListService.sortColumn;
                this.badgeCountService.getBadgeCount();
              }
              if (result) {
                this.toasterNotificationService.showSuccess($localize`:@@: Requisition has been deleted.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
              }
            })
          }
        }
      });
    } else if (checkedVal.length == 1) {
      this.deleteRequisition(checkedVal[0]);
    }
    else {
      Swal.fire({
        icon: 'warning',
        text: 'Please select a Requisition',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        confirmButtonColor: '#299cdb',
      });
    }
    this.checkedValGet = checkedVal;
  }

  deleteRequisition(requisitionId: string, deletingMultiple?: boolean) {
    Swal.fire({
      title: $localize`:@@:Delete Requisition`,
      text: $localize`:@@:Are you sure you want to delete this requisition?`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@:Ok`,
      cancelButtonText: $localize`:@@:Cancel`,
    }).then(result => {
      if (result && result.isConfirmed) {
        this.myFileApiService.deleteRequisition(requisitionId).subscribe((result: boolean | undefined) => {
          if (result) {
            this.toasterNotificationService.showSuccess($localize`:@@: Requisition has been deleted.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
          }
          this.requisitionListService.sortColumn = this.requisitionListService.sortColumn;
        })
      }
    });
  }
}
